export interface TrackedPurchaseImportJob {
  jobId: number;
  storeId: number;
  totalItems?: number;
  createdAt: number;
}

const STORAGE_KEY = 'purchase_import_job_tracker';
export const PURCHASE_IMPORT_JOB_EVENT = 'purchase-import-job-updated';

function isBrowser() {
  return typeof window !== 'undefined' && typeof localStorage !== 'undefined';
}

function normalizeJobs(input: any): TrackedPurchaseImportJob[] {
  if (!Array.isArray(input)) return [];
  return input
    .map((item) => ({
      jobId: Number(item?.jobId),
      storeId: Number(item?.storeId),
      totalItems: item?.totalItems != null ? Number(item.totalItems) : undefined,
      createdAt: Number(item?.createdAt || Date.now())
    }))
    .filter((item) => Number.isInteger(item.jobId) && item.jobId > 0 && Number.isInteger(item.storeId) && item.storeId > 0);
}

function readJobs(): TrackedPurchaseImportJob[] {
  if (!isBrowser()) return [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return normalizeJobs(raw ? JSON.parse(raw) : []);
  } catch {
    return [];
  }
}

function writeJobs(jobs: TrackedPurchaseImportJob[]) {
  if (!isBrowser()) return;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(jobs));
  window.dispatchEvent(new CustomEvent(PURCHASE_IMPORT_JOB_EVENT, { detail: jobs }));
}

export function listTrackedPurchaseImportJobs() {
  return readJobs();
}

export function trackPurchaseImportJob(job: TrackedPurchaseImportJob) {
  const jobs = readJobs();
  const next = jobs.filter((item) => !(item.jobId === job.jobId && item.storeId === job.storeId));
  next.push(job);
  writeJobs(next);
}

export function untrackPurchaseImportJob(jobId: number, storeId: number) {
  const jobs = readJobs().filter((item) => !(item.jobId === jobId && item.storeId === storeId));
  writeJobs(jobs);
}
